const fallbackStorage = {};
export const browserLocalStorage = {
    setItem(key, value) {
        value = String(value);
        try {
            global.localStorage.setItem(key, value);
        }
        catch (err) {
            fallbackStorage[key] = value;
        }
    },
    getItem(key) {
        try {
            return global.localStorage.getItem(key);
        }
        catch (err) {
            return fallbackStorage[key];
        }
    },
    removeItem(key) {
        try {
            return global.localStorage.removeItem(key);
        }
        catch (err) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete fallbackStorage[key];
        }
    },
};
//# sourceMappingURL=local-storage.js.map